import { Location as HistoryLocation } from "history";
import * as React from "react";
import { Helmet } from "react-helmet";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import * as redux from "redux";
import { Paths } from "../../constants";
import { AuthTokenDecoded } from "../../models/auth";
import Settings from "../../settings";
import { AppState } from "../../store";
import { ActionsCommon, ActionsPrimary, ActionsSecondary, AdminHeaderNav } from "../admin";
import { DefaultConnectedDispatch, DefaultConnectedState, DefaultDispatchPropsMap, DefaultStatePropsMap } from "../base";
import { Alerts } from "../generic/Alerts";

const mapStateToProps = (state: AppState, ownProps: OwnProps | undefined): ConnectedState => {
    let hasAdminRole = false;
    if (state.auth.accessToken && state.auth.refreshToken) {
        const decodedToken =  new AuthTokenDecoded(state.auth.accessToken, state.auth.refreshToken);
        hasAdminRole = decodedToken.hasAdminRole();
    }

    return {
        ...DefaultStatePropsMap(state, ownProps),
        isAdminUser: hasAdminRole,
        isLoggedIn: (state.auth.data)
            ? state.auth.data.hasUserRecord
            : false,
        url: state.router.location,
    };
};

const mapDispatchToProps = (dispatch: redux.Dispatch<AppState>): ConnectedDispatch => ({
    ...DefaultDispatchPropsMap(dispatch),
    redirectToLogin: (returnUrl: string) => {
        dispatch(push(Paths.Account.Login + returnUrl));
    },
});

interface OwnProps {
    bodyClass?: string;
    breadcrumb?: JSX.Element[];
    actionsCommon?: JSX.Element | null;
    actionsPrimary?: JSX.Element | null;
    actionsSecondary?: JSX.Element | null;
    mainClass?: string;
    preContent?: JSX.Element | null;
    title: string;
    style?: React.CSSProperties;
    wrapperId?: string;
}

interface OwnState {
}

type ConnectedState = DefaultConnectedState & {
    isAdminUser: boolean;
    isLoggedIn: boolean;
    url: HistoryLocation | null;
};

type ConnectedDispatch = DefaultConnectedDispatch & {
    redirectToLogin: (returnUrl: string) => void;
};

interface OwnState {
}

export class AdminPageComponent extends React.Component<ConnectedState & ConnectedDispatch & OwnProps, OwnState> {

    public componentDidMount() {
        if (typeof document !== "undefined")
            document.body.classList.add(this.props.bodyClass || "admin");

        if (!this.props.isLoggedIn)
            this.props.redirectToLogin(this.getRedirectUrl());

        if (!this.props.isAdminUser)
            this.props.replace(Paths.AccessDenied + "?url=" + this.getEncodedPath());
    }

    public componentWillUnmount() {
        if (typeof document !== "undefined")
            document.body.classList.remove(this.props.bodyClass || "admin");
    }

    public componentDidUpdate() {
        if (!this.props.isLoggedIn)
            this.props.redirectToLogin(this.getRedirectUrl());

        if (!this.props.isAdminUser)
            this.props.replace(Paths.AccessDenied + "?url=" + this.getEncodedPath());
    }

    public getRedirectUrl() {
        let redirectUrl = "";

        if (this.props.url) {
            redirectUrl += "?returnUrl=" + this.props.url.pathname;
        }

        return redirectUrl;
    }

    public render() {
        // if (!this.props.isAdminUser)
        //     return <AccessDenied />;

        let breadcrumb = null;
        if (this.props.breadcrumb && this.props.breadcrumb.length) {
            const links = this.props.breadcrumb.map((b, i) => (<span key={i}>{b} &raquo; </span>));
            breadcrumb = <div className="breadcrumb">{links}</div>;
        }

        const style: React.CSSProperties | undefined = this.props.style;
        const helmet = this.props.title
            ? <Helmet>
                <title>{`${this.props.title} - ${Settings.ClientName}`}</title>
            </Helmet>
            : null;

        let actions: JSX.Element | null = null;
        if (this.props.actionsCommon || this.props.actionsPrimary || this.props.actionsSecondary) {
            actions = <div id="actions">
                {this.props.actionsCommon ? <ActionsCommon>{this.props.actionsCommon}</ActionsCommon> : null}
                {this.props.actionsPrimary ? <ActionsPrimary>{this.props.actionsPrimary}</ActionsPrimary> : null}
                {this.props.actionsSecondary ? <ActionsSecondary>{this.props.actionsSecondary}</ActionsSecondary> : null}
            </div>;
        }

        return <div id="page" style={style}>
            {helmet}

            <header id="header">
                <AdminHeaderNav sectionTitle={this.props.title} />

                {actions}
            </header>

            {breadcrumb}

            <div className={this.props.mainClass || ""} id="main">
                <Alerts />
                {this.props.preContent}
                <div id="content">
                    {this.props.children}
                    <div className="clear"></div>
                </div>
            </div>

            <div id="credit">
                <a href="https://www.webitects.com">Designed and built in Chicago by <strong>Webitects</strong></a>
            </div>
        </div>;
    }

    private getEncodedPath() {
        if (this.props.url)
            return encodeURIComponent(decodeURIComponent((this.props.url.pathname + "") + (this.props.url.search + "") + (this.props.url.hash + "")));
        return "";
    }
}

export const AdminPage: React.ComponentClass<OwnProps> = connect(mapStateToProps, mapDispatchToProps)(AdminPageComponent);



// WEBPACK FOOTER //
// ./src/components/page/AdminPage.tsx